export { MonthlyAnalyticsTable } from './MonthlyAnalyticsTable'
